<template>
  <div>
    
    <template v-if="hasPaid">
        <div class="cover cover--right cover--top cover--small" :style="'background-image: url(' + require('@/assets/cover-contribute.jpg') + ')'">
            <div class="cover__content">
                <h1 class="cover__title">You have the power<br>to make a difference.</h1>
            </div>
        </div>
        <div class="wrapper wrapper--spaced wrapper--centered white-box">
            <h1 class="title title--spaced">Thank you for your contribution. </h1>       
            <p class="text">Your support is an essential part of our campaign to fight back against politicians who over tax, over spend and keep forgetting who they were elected to serve (THE PEOPLE).</p>
            <p class="text">Thank you for supporting Aaron’s campaign and helping to reshape B.C. politics.</p>
            <p class="text">Sincerely,</p>
            <p class="text">The Aaron Gunn Team</p>
        </div>
    </template>

    <template v-else>
        <div class="cover cover--right cover--top" :style="'background-image: url(' + require('@/assets/cover-contribute.jpg') + ')'">
            <div class="cover__content">
                <h1 class="cover__title">You have the power to make a difference.</h1>
                <h2 class="cover__subtitle">It’s time to help Aaron turn British Columbia around.</h2>
            </div>
        </div>

        <div class="wrapper wrapper--spaced wrapper--centered white-box">

            <p class="text">On October 9th, Aaron Gunn announced his intention to become leader of the BC Liberal Party<br>and more importantly, the next Premier of British Columbia.</p>
            <h1 class="title title--red" style="margin-bottom: 40px;">Contribute to our campaign and help Aaron make history!</h1>

            <form class="form" method="post" action="/webservices/payment.php">
                <div class="form__item form__item--full">
                    <h1 class="title title--small">Amount you’d like to contribute*</h1>
                    <div class="segment">
                        <input class="segment__input" type="radio" name="amount" value="100" id="100" @change="handleChange" checked /><label class="segment__label" for="100">$100</label>
                        <input class="segment__input" type="radio" name="amount" value="200" id="200" @change="handleChange" checked /><label class="segment__label" for="200">$200</label>
                        <input class="segment__input" type="radio" name="amount" value="500" id="500" @change="handleChange"/><label class="segment__label" for="500">$500</label>
                        <input class="segment__input" type="radio" name="amount" value="1268.07" id="1268.07" @change="handleChange"/><label class="segment__label" for="1268.07" style="flex: none;">$1,268.07</label>                            
                        <input class="segment__input" type="radio" name="amount" value="other" id="other" @change="handleChange" /><label class="segment__label" for="other">Other</label>
                    </div>
                </div>
                <div class="form__item" id="other_amount"  style="margin-bottom: 30px;"><label>Enter amount*</label><input name="other_amount" type="number" max="1268.07" autocomplete="off"/></div>

                <div class="form__item form__item--duo"><label>First Name*</label><input name="firstname" type="text" autocomplete="given-name" required/></div>
                <div class="form__item form__item--duo"><label>Last Name*</label><input name="lastname" type="text" autocomplete="family-name" required/></div>
                <div class="form__item"><label>Address*</label><input name="address" type="text" autocomplete="address-line1" placeholder="123 Main St" required/></div>
                <div class="form__item form__item--duo"><label>City*</label><input name="city" type="text" autocomplete="address-level2" placeholder="Victoria" required/></div>
                <div class="form__item form__item--duo"><label>B.C. Postal Code*</label><input name="zip" type="text" autocomplete="postal-code" placeholder="V8V 1X4" pattern="[vV][0-9][A-Za-z][\s]?[0-9][A-Za-z][0-9]" required/></div>
                <div class="form__item"><label>Provice*</label><select disabled><option value="bc">British Columbia</option></select></div>
                <div class="form__item form__item--duo"><label>Email*</label><input name="email" type="email" autocomplete="email" required/></div>
                <div class="form__item form__item--duo"><label>Phone*</label><input name="phone" type="tel" autocomplete="tel" placeholder="123-456-7890" pattern="[1]?[-\s]?[(]?\d{3}[)\s]?[-\s]?\d{3}[-\s]?\d{4}"/></div>

                <div class="form__item"><label class="option"><input type="checkbox" name="resident" value="yes" required>I confirm I am a resident of B.C. and a Canadian citizen (or permanent resident)</label></div>               
                <div class="form__item"><label class="option"><input type="checkbox" name="join" value="yes">Please add me to Aaron’s email update list for the latest content and campaign updates.</label></div> 

                <input type="hidden" name="periodicity" value="one"/>
                <input type="hidden" name="source" value="campaign_donation"/>

                <input style="margin-top: 30px; margin-bottom: 10px;" type="submit" value="Proceed with Donation" class="button button--red"/>

                <p class="disclaimer">*Disclaimer: $1268.07 is the maximum donation to a political candidate that is allowed by law for 2021 (in British Columbia) although you can donate the maximum amount to multiple candidates. No tax receipt is unfortunately allowed.</p>
            </form>

            <h1 class="title title--small" style="margin-top: 60px">If you would prefer to donate by e-transfer and help us save on<br>credit card processing fees, that's an option too. </h1>
            <h1 class="title title--small title--red">Etransfer can be sent to donations@aarongunn.ca. Please ensure your etransfer contains your full name and residential address. Cheques can be made out to ‘Aaron Gunn for Leader Campaign’ and sent to donations@aarongunn.ca.</h1>

        </div>

        <div class="blue-box--light">
            <div class="wrapper wrapper--spaced wrapper--centered">
                <p  class="text">After building the largest social media following for a political figure in the province, Aaron is ready to restore and rebuild the BC Liberal Party and take the fight to the NDP. By contributing below, you can send a message to the political establishment that it’s time for change.</p> 
                <h1 class="title title--white title--spaced">It’s time to bring back common sense.</h1>                  
                <iframe src="https://www.facebook.com/plugins/video.php?href=https%3A%2F%2Fwww.facebook.com%2FAaronGunn.ca%2Fvideos%2F229128302367901%2F&width=400&show_text=false&appId=372995680756245&height=400" width="400" height="400" style="border:none;overflow:hidden" scrolling="no" frameborder="0" allowfullscreen="true" allow="autoplay; clipboard-write; encrypted-media; picture-in-picture; web-share" allowFullScreen="true"></iframe>
            </div>
        </div>
    </template>
  </div>
</template>

<script>
export default {

    mounted() {
        this.handleChange();
        this.changeContributionType();
    },
    data() {
        return {
            periodicity: 'one'
        }
    },
    computed: {
        hasPaid () {
            return this.$router.currentRoute.query.hasOwnProperty('paid');
        }
    },
    methods: {
        handleChange(event) {
            if(document.getElementById("other").checked || (event && event.target.value == 'other')) {
                document.getElementById('other_amount').style.display = '';
                document.querySelector("input[name=other_amount]").required = true;
                document.querySelector("input[name=other_amount]").pattern = "\\d+(\\.\\d{2})?";
            }
            else {
                document.getElementById('other_amount').style.display = 'none';
                document.querySelector("input[name=other_amount]").removeAttribute("pattern"); 
            }
        },

        changePeriodicity(event) {
            this.periodicity = event.target.value;
        },
    }

}
</script>

<style scoped>
.disclaimer { margin-top: 30px; font-size: 1.5rem; }
.segment { width: 100%; display: flex; position: relative; user-select: none; border-radius: 3px; color: white; font-weight: 600; align-items: center; }
.segment__input { display:none; } 
.segment__input:checked + .segment__label { color: #fff; background: #062573; }
.segment__label { flex: 1; text-align: center; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; cursor: pointer; padding: 8px 5px; background: #AAB7DA; } 
.segment__label:not(:last-child) { border-right: 1px solid #fff; }
.segment__label:first-of-type { border-radius: 3px 0 0 3px; }
.segment__label:last-of-type { border-radius: 0 3px 3px 0; } 

</style>
